import React, { useEffect, useState } from 'react';
import loadable from '@loadable/component';
import Loader from '@components/Loader/index';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const CarouselCodeSplit = loadable(() => import('./CarouselCodeSplit'), {
  fallback: (
    <div className="flex h-full  w-full items-center justify-center">
      <Loader></Loader>
    </div>
  ),
});

export default function FellowshipCarousel(props) {
  return (
    <FadeInWhenVisible
      variants={{
        visible: { opacity: 1, y: 0 },
        hidden: { opacity: 0, y: 100 },
      }}
    >
      <CarouselCodeSplit {...props}></CarouselCodeSplit>
    </FadeInWhenVisible>
  );
}

function FadeInWhenVisible(props) {
  const controls = useAnimation();
  const [ref, inView] = useInView();
  const [hasComeInViewOnce, setHasComeInViewOnce] = useState(false);

  useEffect(() => {
    if (inView) {
      controls.start('visible');
      setHasComeInViewOnce(true);
    }
  }, [controls, inView]);

  return (
    <motion.div
      ref={ref}
      animate={controls}
      initial="hidden"
      transition={{ duration: props.duration ? props.duration : 0.8 }}
      {...props}
      //   exit="hidden"
    >
      {hasComeInViewOnce ? props.children : <Placeholder></Placeholder>}
    </motion.div>
  );
}

function Placeholder() {
  return <div className="h-[300px]"></div>;
}
